import {createComponent} from '../bridge/create-component';
import {EVENT} from '../bridge/constants';
import type {BridgeComponentOptions} from '../bridge/types';
import type {BizumModalProps} from './types';
import {config} from '../config';
import {modalContainerTemplate} from '../container';

const componentOptions: BridgeComponentOptions<BizumModalProps> = {
  tag: 'monei-bizum',
  url: config.bizumUrl,
  autoResize: {
    width: false,
    height: false
  },
  containerTemplate: (params) => {
    if (!params.frame) return;
    if (params.props.isHidden) {
      const div = params.doc.createElement('div');
      div.setAttribute('id', params.uid);
      div.style.display = 'none';
      div.appendChild(params.frame);
      if (params.placeholder) div.appendChild(params.placeholder);
      return div;
    }
    return modalContainerTemplate(params);
  },
  defaultProps: ({event}) => ({
    onBeforeClose: () => {
      event.trigger(EVENT.BEFORE_CLOSE);
    }
  })
};

export const BizumModal = createComponent<BizumModalProps>(componentOptions);
